import { Component, OnInit } from '@angular/core';
import { ClaimDetailsItem } from 'src/app/model/claimdetails';
import { CommonService } from 'src/app/services/common.service';
import { StorageService } from 'src/app/services/storage.service';
import { RegisterDevice } from 'src/app/model/register-device';
import { MSSPService } from 'src/app/services/mssp.service';
import { CoverageItem } from 'src/app/model/coverage-item';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientItem } from 'src/app/model/client-item';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { RequestIntegrationItem } from 'src/app/model/client-policy-detail';

@Component({
    selector: 'app-tracing',
    templateUrl: './tracing.component.html',
    styleUrls: ['./tracing.component.scss']
})

export class TracingPageComponent implements OnInit {
    faArrowLeft = faArrowLeft
    tracking: any;
    device!: any;
    msspItem!: CoverageItem;
    clientItems!: RequestIntegrationItem[];
    output: number[] = [];

    policy: string = ""
    idCliente: string = ""
    apikey: string = ""
    client: string = ""
    deviceId: string = ""
    claimNumber: string = ""
    certificate: string = ""
    loading:boolean = false;
    dealerCode: string = '';

    constructor(
        public msspService: MSSPService,
        public commonService: CommonService,
        private local: StorageService,
        private route: ActivatedRoute,
        private storageService: StorageService,
        private router: Router
    ) {
        this.deviceId = this.route.snapshot.params['deviceId'];
        this.claimNumber = this.route.snapshot.params['claimNumber'];

        this.policy = this.storageService.getData('policy');
        this.idCliente = this.storageService.getData('idClient');
        this.apikey = this.storageService.getData('apiKey');
        this.client = this.storageService.getData('client');
        this.certificate = this.storageService.getData('certificado');
        this.dealerCode = this.storageService.getData('dealerCode');
    }

    ngOnInit(): void {
        this.loading = true
        console.log("ccf",  this.idCliente, this.apikey, this.client, this.certificate )
        this.commonService.dealerCode = (this.commonService.dealerCode === '') ? this.storageService.getData('dealerCode') : 'EA13';
        this.commonService.getlistProducts(this.policy, this.idCliente, this.apikey, this.client, this.certificate, 'undefined', this.dealerCode)
            .subscribe(({ reqClient, reqMssp }) => {
// ToDo modificar a variable de servicio
                this.clientItems = this.commonService.capitalLetter(reqClient.data.RequestIntegration)
                this.msspItem = reqMssp.data.Coverages.find(this.commonService.typeValidation)

                var oneDev = this.clientItems.find(el => el.SRNumber === this.deviceId)
                if (oneDev) {
                    this.device = oneDev
                }else{
                    var deviceMssp = reqMssp.data.ItemInfo[0].RegisteredDevices.find((res:any) => res.SerialNumber == this.deviceId)
                    var dateArray = deviceMssp.DevicePurchaseDate.split(" ")[0]
                    this.device = new ClientItem(
                        deviceMssp.SerialNumber,
                        deviceMssp.ItemDescription,
                        deviceMssp.Model,
                        dateArray,
                        "",          
                        deviceMssp.Make,
                        Number(deviceMssp.DevicePurChasePrice),
                        deviceMssp.RegisteredDeviceName,
                        "",
                        deviceMssp.Model,
                        [],
                        false
                      ) 
                }
                    var claimdetailsItem = new ClaimDetailsItem(
                        this.idCliente,
                        this.claimNumber,
                        this.commonService.dealerCode,
                        this.commonService.companyCode
                    )
                    this.msspService.getClaimDetails(claimdetailsItem).subscribe((req) => {
                        if (req) {
                            this.loading = false
                            this.tracking = req.data
                            var newInitDate = new Date(this.tracking.CreatedDate)
                            var newEndDate = new Date(this.tracking.ClosedDate)
                            var currentDate = new Date()
                            var days = null;
                            if (newEndDate.getTime()) {
                                days = Math.floor((newEndDate.getTime() - newInitDate.getTime()) / 1000 / 60 / 60 / 24).toString();

                            }
                            else {
                                days = Math.floor((currentDate.getTime() - newInitDate.getTime()) / 1000 / 60 / 60 / 24).toString();
                            }
                            if (Number(days) > 0) {
                                if (Number(days) <= 9) {
                                    this.output.push(0);
                                    this.output.push(+days.charAt(0));
                                }
                                else {
                                    for (var i = 0, len = days.length; i < len; i += 1) {
                                        this.output.push(+days.charAt(i));
                                    }
                                }

                            }
                            else{
                                this.output = [0,1]
                            }
                        }
                    })
                
            })

    }

    findDevice(registerDevices: RegisterDevice[], serialNumber: string): RegisterDevice | null {
        if (registerDevices.length != 0) {
            var registerDev = registerDevices.find(res => res.SerialNumber === serialNumber)
            if (registerDev) return registerDev
        }
        return null
    }

    stepOn(){
        const token = this.storageService.getData('encodedToken');
        this.router.navigate(['/'], { queryParams: { q: token  } });
    }

    sortBy(prop: string) {
        return this.tracking.ExtendedStatus.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
      }

}

